import { KYMW6501InputModel } from '../kymw6501/vo/kymw6501-input.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from './../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OrderCodeTextInputComponent } from './../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { GetCwsTimeSaleListService } from './api-services/get-cws-time-sale-list.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6500Model } from './kymw6500.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { CellRange, CellType, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW6501Component } from '../kymw6501/kymw6501.component';
import { CwsPlanCategoryCodeComboBoxComponent } from '../../../../app/commons/kymw02/combo-box/cws-plan-category-code-combo-box/cws-plan-category-code-combo-box.component';
import { SaveCwsTimeSaleListService } from './api-services/save-cws-time-sale-list.service';
import { Point } from '@grapecity/wijmo';
import { Menu } from '@grapecity/wijmo.input';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

/**
 * ECタイムセールマスタ一覧画面を管理するクラス
 *
 * @export KYMW6500Component
 * @class KYMW6500Component
 */
@Component({
  selector: 'app-kymw6500',
  templateUrl: 'kymw6500.component.html',
  styleUrls: ['kymw6500.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6500Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw6500Model: KYMW6500Model = new KYMW6500Model();

  @ViewChild('dtg_TimeSaleList', { static: true }) dtg_TimeSaleList: FlexGrid;
  @ViewChild('cmb_CategoryCode', { static: true }) cmb_CategoryCode: CwsPlanCategoryCodeComboBoxComponent;
  @ViewChild('btn_Display', { static: true }) btn_Display: ElementRef;
  @ViewChild('txti_OrderCodeFr', { static: true }) txti_OrderCodeFr: OrderCodeTextInputComponent;
  @ViewChild('txti_OrderCodeTo', { static: true }) txti_OrderCodeTo: OrderCodeTextInputComponent;

  // コンテキストメニュー(右クリック)
  private cmDtgTimeSaleList: Menu;

  /**
   *Creates an instance of KYMW6500Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW6500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getCwsTimeSaleListService: GetCwsTimeSaleListService,
    private saveCwsTimeSaleListService: SaveCwsTimeSaleListService,
    private fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW6500Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6500';
    this.kymw6500Model.kymw6500Component = this;
    // 行ヘッダの幅を0にしてレイアウト設定
    this.dtg_TimeSaleList.rowHeaders.columns[0].width = 0;
    this.dtg_TimeSaleList.selectionMode = SelectionMode.Row;

    // コンテキストメニュー設定
    this.setContextMenu1();

    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   *
   * @memberof KYMW6500Component
   */
  public plessEnabledSetting() {
    // ボタン活性制御
    this.plessEnabled(this.btn_Display, false);

    // デフォルトフォーカス設定
    this.txti_OrderCodeFr.setFocus();
  }

  /**
   * 「受注コード(From)」変更イベント処理
   *
   * @memberof KYMW6500Component
   */
  public eventOrderCodeFr_CHANGEHandler(): void {
    // タイムセール一覧をクリア
    this.kymw6500Model.timeSaleList = new Array<any>();

    // 受注コードのチェック
    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCodeFr.selectedCatalogID)) {  // 入力完了の場合
      // 活性制御
      this.plessEnabled(this.btn_Display, true);

      // コンボボックスデータ取得
      this.cmb_CategoryCode.initFocusItem = this.txti_OrderCodeFr;
      this.cmb_CategoryCode.selectedOrderCode = this.kymw6500Model.orderCodeFr;
      this.cmb_CategoryCode.updateCategoryList();
    } else {                                                                    // 入力未完了の場合
      // 活性制御
      this.plessEnabled(this.btn_Display, false);
      // コンボボックスクリア
      this.cmb_CategoryCode.clear();
    }
  }

  /**
   * 「受注コード(To)」変更イベント処理
   *
   * @memberof KYMW6500Component
   */
  public eventOrderCodeTo_CHANGEHandler(): void {
    // タイムセール一覧をクリア
    this.kymw6500Model.timeSaleList = new Array<any>();
  }

  /**
   * 「カテゴリ」コンボボックス変更イベント処理
   *
   * @memberof KYMW6500Component
   */
  public eventCategoryCode_CHANGEHandler(): void {
    // タイムセール一覧をクリア
    this.kymw6500Model.timeSaleList = new Array<any>();
  }

  /**
   * 「表示」ボタン押下イベント処理
   *
   * @memberof KYMW6500Component
   */
  public eventDisplay_CLICKHandler(): void {
    const vo: {
      orderCodeFr: '',
      orderCodeTo: '',
      categoryCode: ''
    } = this.kymw6500Model.getTimeSaleDataVO();

    // データ取得
    this.getCwsTimeSaleListService.execute(this.kymw6500Model, vo);
  }

  /**
   * 「登録」ボタン押下イベント処理
   *
   * @memberof KYMW6500Component
   */
  public eventEntry_CLICKHandler(): void {
    // 変数定義
    let kymw6501InputVO: KYMW6501InputModel;                                    // タイムセールマスタ設定画面Input用VO

    // タイムセールマスタ設定画面Input用VO取得
    kymw6501InputVO = this.kymw6500Model.getKYMW6501InputVO(KYMW6501InputModel.PROCES_DIV_REGIST);

    // タイムセールマスタ設定画面を表示
    const componentRef = this.dialogService.openModal(KYMW6501Component);
    const instance = componentRef.componentInstance as KYMW6501Component;
    instance.parent = this;
    // タイムセールマスタ設定画面Input用VO取得
    instance.setInterfaceParam(kymw6501InputVO);
    instance.closeFunction = () => {
      this.eventSubWindowClose();
      componentRef.close();
    };
  }

  /**
   * コンテキスト「修正」メニュー選択イベント
   *
   * @param event:イベント
   */
  public eventEditTimeSale_CLICKHandler(): void {
    // 変数定義
    let kymw6501InputVO: KYMW6501InputModel;                                    // タイムセールマスタ設定画面Input用VO

    // 選択行を保持
    // 画面で選択した行データと同じデータのインデックス番号をpageTemplateListから取得
    // 画面のグリッドをソートすると行番号をそのまま使用することができなくなるため
    const targetIndex: number = this.kymw6500Model.timeSaleList.findIndex(
      timeSale => timeSale.OrderCode === this.dtg_TimeSaleList.selectedItems[0].OrderCode
      && timeSale.CategoryCodeName === this.dtg_TimeSaleList.selectedItems[0].CategoryCodeName);

    this.kymw6500Model.selectedRow = targetIndex;

    // タイムセールマスタ設定画面Input用VO取得
    kymw6501InputVO = this.kymw6500Model.getKYMW6501InputVO(KYMW6501InputModel.PROCES_DIV_UPDATE);

    // 必須項目のチェック
    // 受注コード
    if (PlessViewUtilsSub.isEmpty(kymw6501InputVO.OrderCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['受注コード']);
      return;
    }

    // カテゴリコード
    if (PlessViewUtilsSub.isEmpty(kymw6501InputVO.CategoryCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['カテゴリコード']);
      return;
    }

    // タイムセールマスタ設定画面を表示
    const componentRef = this.dialogService.openModal(KYMW6501Component);
    const instance = componentRef.componentInstance as KYMW6501Component;
    instance.parent = this;
    instance.setInterfaceParam(kymw6501InputVO);
    instance.closeFunction = () => {
      this.eventSubWindowClose();
      componentRef.close();
    };
  }

  /**
   * サブ画面終了時の再描画処理
   *
   * @memberof KYMW6500Component
   */
  public eventSubWindowClose(): void {
    // 企画回コードのチェック
    if (!PlessViewUtilsSub.isEmpty(this.txti_OrderCodeFr.selectedCatalogID)) {  // 表示ありの場合
      // 選択行の保持
      this.kymw6500Model.selectedRow = this.dtg_TimeSaleList.selection.row;
      this.kymw6500Model.scrollPosition = this.dtg_TimeSaleList.scrollPosition;

      const vo: {
        orderCodeFr: '',
        orderCodeTo: '',
        categoryCode: ''
      } = this.kymw6500Model.getTimeSaleDataVO();

      // データ取得
      this.getCwsTimeSaleListService.execute(this.kymw6500Model, vo);
    }
  }

  /**
   * データグリッドの更新後を検知する
   *
   * @memberof KYMW6500Component
   */
  public onItemsSourceChanged(): void {
    if (this.kymw6500Model.selectedRow !== -1) {
      // 保持した行番号がある場合、フォーカスを充て、行番号をクリア
      this.dtg_TimeSaleList.select(new CellRange(this.kymw6500Model.selectedRow, -1));
      this.dtg_TimeSaleList.scrollPosition = new Point(this.kymw6500Model.scrollPosition.x, this.kymw6500Model.scrollPosition.y);
      this.kymw6500Model.selectedRow = -1;
      this.kymw6500Model.scrollPosition = new Point(0, 0);
    } else {
      // 上記以外選択行が-1となるため、フォーカスが外れる
      this.dtg_TimeSaleList.select(this.kymw6500Model.selectedRow, -1);
    }
  }

  private setContextMenu1(): void {
    this.cmDtgTimeSaleList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: 'タイムセールマスタ修正', caption: 'タイムセールマスタ修正', cmd: 'editTileSale' },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgTimeSaleList.selectedValue) {
            case 'editTileSale':
              this.eventEditTimeSale_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_TimeSaleList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.cmDtgTimeSaleList !== undefined) {
        this.eventContextMenu_MENUSELECTHandler(e);
        // メニュー表示
        this.cmDtgTimeSaleList.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    this.initForcedEnabledForContextMenuItemByScreenMode(this.cmDtgTimeSaleList.itemsSource[0], 'none');
  }

  /**
   * ポイントリスト コンテキストメニュー項目活性・非活性制御(ポイント)
   *
   * @private
   * @returns
   * @memberof KYMW6500Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  public eventContextMenu_MENUSELECTHandler(e: any): void {
    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode: boolean = <boolean>false;
    if (this.dtg_TimeSaleList.selection.row !== -1) {
      contextMenuEnabledMode = true;
    }

    // 画像変更のコンテキストメニューアイテムを探し出し、権限を設定する
    this.cmDtgTimeSaleList.itemsSource.forEach((item: { enabled: boolean; caption: string; }) => {
      item.enabled = this.setContextMenuEnabled(item, contextMenuEnabledMode);
    });
  }
}
